import { API_DATA_FORMAT, API_STATUS } from 'core-lib/constants/network';
import { EventCategoryName } from 'core-lib/types/Events';
import { ApiDataFormat } from 'core-lib/types/Network';
import React from 'react';

import { getDefaultAttributes, trackCustomGTMEvent, trackEvent } from 'core-lib/utils/events';
import { signInClicked } from '../constants';
import { BodyType, ResendBodyType, resendOTP, ResponseType, sendOTP } from '../services/sendOTP';
import { getOriginalFromSigninWithBase } from '../../core-lib/utils/source';

interface ApiDataType extends ApiDataFormat {
  data: null | ResponseType;
}

export type OutputType = {
  apiCall: ApiDataType;
  sendOtp: (body: BodyType) => void;
  resendOtp: (body: ResendBodyType) => void;
};

export function useSendOTP(): OutputType {
  const [apiCall, setApiCall] = React.useState<ApiDataType>({
    ...API_DATA_FORMAT,
  });

  async function sendOtp(body: BodyType) {
    setApiCall({ ...apiCall, apiStatus: API_STATUS.in_progress });
    const { response, error } = await sendOTP(body);
    if (response) {
      setApiCall({ ...apiCall, apiStatus: API_STATUS.success, data: response });
      trackEvent({
        name: signInClicked.name,
        defaultAttr: getDefaultAttributes(),
        attributes: {
          [signInClicked.attributes.url]: 'user/b2c/otp/send/',
          [signInClicked.attributes.mode]: 'phone',
          [signInClicked.attributes.mobileNumber]: body.phoneNumber,
          [signInClicked.attributes.category]: 'user onboarding',
        },
      });
      trackCustomGTMEvent({
        eventName: `pm_login_started${sessionStorage.getItem('source_initial_page_route').replace(/[\/-]/g, '_')}`,
        attributes: {
          category: EventCategoryName.Signin,
          phone_number: body.phoneNumber,
          redirected_from: getOriginalFromSigninWithBase(),
        },
      });
    }
    if (error) {
      setApiCall({
        ...apiCall,
        apiStatus: API_STATUS.failure,
        data: null,
        apiError: error,
      });
    }
  }

  async function resendOtp(body: ResendBodyType) {
    setApiCall({ ...apiCall, apiStatus: API_STATUS.in_progress });
    const { response, error } = await resendOTP(body);
    if (response) {
      setApiCall({ ...apiCall, apiStatus: API_STATUS.success, data: response });
      trackEvent({
        name: signInClicked.name,
        defaultAttr: getDefaultAttributes(),
        attributes: {
          [signInClicked.attributes.mode]: 'phone',
          [signInClicked.attributes.mobileNumber]: body.phone_number,
          [signInClicked.attributes.category]: 'user onboarding',
        },
      });
      trackCustomGTMEvent({
        eventName: `pm_login_started${sessionStorage.getItem('source_initial_page_route').replace(/[\/-]/g, '_')}`,
        attributes: { category: EventCategoryName.Signin, phone_number: body?.phone_number },
      });
    }
    if (error) {
      setApiCall({
        ...apiCall,
        apiStatus: API_STATUS.failure,
        data: null,
        apiError: error,
      });
    }
  }

  return {
    sendOtp,
    resendOtp,
    apiCall,
  };
}
